import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  exerciseWrapper: {
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 1),
    },
  },

  filesWrapper: {
    marginTop: 8,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },

  ownerWrapper: {
    ...theme.mixins.appContainer,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  containerWithBackground: {
    ...theme.mixins.appContainer,
    padding: theme.spacing(2),
    marginBottom: 0,
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
  },

  optionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: '100%',
  },
  optionsRow: {
    width: '100%',
    flex: 1,
    maxWidth: '100%',
    display: 'flex',
    gap: theme.spacing(1),

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  emptyBlock: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  linkWrapper: {
    ...theme.mixins.appLink,
  },
  exerciseTitle: {
    flex: 1,
    minWidth: 0,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  galleryWrapper: {
    ...theme.mixins.appContainer,
    marginTop: theme.spacing(1),
  },
}));
